export default __webpack_public_path__ + "static/media/rocket_anim_22.820251a2.png";